export default "__VITE_ASSET__e86acac1__"